<template>
    <TopNav></TopNav>
		<h1>Ünlü Uyumu Doğrulama</h1>
		<fieldset>
      <legend>Ünlü Uyumu Doğrulama Aracı</legend>
      <label for="inputKelime">Kelime:</label> <input type="text" v-model="inputKelime" id="inputKelime">
      <br><br>
      Büyük Ünlü Uyumu: <span v-bind:class="classObject()">{{ durum() }}</span>
        <br>
      Küçük Ünlü Uyumu: <span v-bind:class="classObject2()">{{ durum2() }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "UnluUyumu",
  data() {
    return {
        inputKelime: ""
    }
  },
  components: {
    TopNav
  },
  methods: {
    durum: function () {
      if (this.isValid(this.inputKelime)) {
        return "var";
      } else if (this.isValid(this.inputKelime) == false && this.inputKelime.length > 0) {
        return "yok";
      } else {
        return "";
      }
    },
    durum2() {
      if (this.isValid2(this.inputKelime)) {
        return "var";
      } else if (this.isValid2(this.inputKelime) == false && this.inputKelime.length > 0) {
        return "yok";
      } else {
        return "";
      }
    },
    classObject: function () {
      if (this.isValid(this.inputKelime)) {
        return {
          "olumlu": true
        }
      } else {
        return {
          "olumsuz": true
        }
      }
    },
    classObject2: function () {
      if (this.isValid2(this.inputKelime)) {
        return {
          "olumlu": true
        }
      } else {
        return {
          "olumsuz": true
        }
      }
    },
    isValid(kelime) {
      let kalinSize = kelime.match(/(a|ı|o|u)/g);
      if (kalinSize === null) {
          kalinSize = [];
      }

      let inceSize = kelime.match(/(e|i|ö|ü)/g);
      if(inceSize == null) {
        inceSize = [];
      }

      if ((kalinSize.length > 0 && inceSize.length == 0) || (kalinSize.length == 0 && inceSize.length > 0)) {
        return true
      }
      else {
        return false;
      }
    },
    isValid2(kelime) {
      let seslilerArr = kelime.match(/(a|ı|o|u|e|i|ö|ü)/g);
      if (seslilerArr === null || seslilerArr <= 2) {
        seslilerArr = [];
        return false;
      }
      for (let i=0; i < seslilerArr.length - 1; i++) {
        if (seslilerArr[i] === "a" || seslilerArr[i] === "e" || seslilerArr[i] === "ı" || seslilerArr[i] === "i") {
          if(!this.duzlukKurali(seslilerArr[i], seslilerArr[i+1])) {
            return false;
          }
        }
        if (seslilerArr[i] === "o" || seslilerArr[i] === "ö" || seslilerArr[i] === "u" || seslilerArr[i] === "ü") {
          if (!this.yuvarlaklikKurali(seslilerArr[i], seslilerArr[i+1])) {
            return false;
          }
        }
      }
      return true;
    },
    duzlukKurali(ilkHarf, ikinciHarf) {
    if ((ilkHarf === "a" || ilkHarf === "e" || ilkHarf === "ı" || ilkHarf === "i") &&
    (ikinciHarf === "a" || ikinciHarf === "e" || ikinciHarf === "ı" || ikinciHarf === "i")) {
      return true;
    }
    else {
      return false;
    }
    },
    yuvarlaklikKurali(ilkHarf, ikinciHarf) {
      if ((ilkHarf === "o" || ilkHarf === "ö" || ilkHarf === "u" || ilkHarf === "ü") &&
      (ikinciHarf === "a" || ikinciHarf === "e" || ikinciHarf === "u" || ikinciHarf === "ü")) {
        return true;
      }
      else {
        return false;
      }
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 50px;
}

footer section a {
  margin: 20px;
}

label {
  display: inline-block;
  min-width: 110px;
}

#inputKelime {
    width: 98%;
}

.olumlu {
  color: #008A00
}

.olumsuz {
  color: #EB0000
}
</style>
